import { Flex, Table } from 'antd';
import { translateX } from 'utils/helpers';
import ImageDescription from 'components/jarvisly-components/others-old/ImageDescription';
import {
  FormButton,
  JarvislyEditViewRemoveItem,
} from 'components/jarvisly-components/others/FormComponents';
import appService from 'services/appService';
import { PlusOutlined } from '@ant-design/icons';
import { capitalize } from 'lodash';
import dayjs from 'dayjs';
import appsindicoService from 'services/appsindicoService';

// GLOBAL VARIABLES ************************************************************
// *****************************************************************************

// COMPONENT *******************************************************************
// *****************************************************************************
const JarvislyDependentsIndex = props => {
  // props deconstruction ------------------------------------------------------
  const {
    _id,
    isWorking,
    setIsWorking,
    document,
    mode,
    setShowDependentsModal,
    setSelectedRecord,
    refreshDocument,
  } = props;

  // local variables -----------------------------------------------------------
  const isDisabled = isWorking || mode === 'view';
  const tableColumns = buildTableColumns();

  // component states ----------------------------------------------------------

  // hooks ---------------------------------------------------------------------

  // methods -------------------------------------------------------------------
  const onAdd = () => {
    setSelectedRecord(null); // Clear selected record for adding new dependent
    setShowDependentsModal(true); // Open modal
  };

  const onEdit = record => {
    setSelectedRecord(record); // Set the selected record for editing
    setShowDependentsModal(true); // Open modal
  };

  const onDelete = async record => {
    setIsWorking(true);
    await appsindicoService.removeArrayId(
      record,
      'v1/units',
      _id,
      'dependentsIds',
      'v1/dependents',
    );
    refreshDocument(_id, true);
  };

  // UI COMPONENTS -------------------------------------------------------------
  return (
    <>
      {/* Debugging: Output the dependents data */}

      <Table
        rowKey={record => record._id} // Assuming each dependent has a unique _id
        columns={tableColumns.filter(x => !x.hidden)}
        dataSource={document?.__dependents || []}
        pagination={false}
        loading={!document || isWorking}
      />

      <Flex justify={appService.isMobile() ? 'center' : 'end'}>
        <FormButton
          title="add_dependents"
          className="m-3"
          style={{ width: 200 }}
          icon={<PlusOutlined />}
          disabled={isDisabled}
          onClick={onAdd}
        />
      </Flex>
    </>
  );

  // INTERNAL FUNCTIONS ========================================================
  // ===========================================================================
  function buildTableColumns() {
    return [
      {
        title: translateX('name'),
        dataIndex: 'name',
        className: 'text-truncate',
        render: (_, record) => {
          return (
            <div className="d-flex" style={{ width: 200 }}>
              <ImageDescription
                shape="circle"
                title={capitalize(record?.name)}
                subtitle={translateX(record?.gender)}
                foreColor={record?.foreColor}
                backColor={record?.backColor}
              />
            </div>
          );
        },
      },
      {
        title: translateX('mobile'),
        dataIndex: 'mobile',
        render: (_, record) => {
          return (
            <>
              <div>{record?.mobile}</div>
            </>
          );
        },
      },
      {
        title: translateX('living'),
        dataIndex: 'living',
        render: (_, record) => {
          return (
            <>
              {record?._metadata?.audit?.updatedAt &&
                dayjs(record._metadata.audit.updatedAt).fromNow()}
            </>
          );
        },
      },

      {
        title: translateX('actions'),
        dataIndex: 'actions',
        width: 120,
        className: 'text-center',
        render: (_, record) => {
          return (
            <JarvislyEditViewRemoveItem
              onEdit={onEdit}
              onDelete={onDelete}
              record={record}
              recordId={record?.entityId}
              isDisabled={isDisabled}
              deleteTitle={translateX(
                'remove_this_item',
                ['%ITEM%'],
                ['contact'],
              )}
            />
          );
        },
      },
    ].filter(x => !x.hidden);
  }
};

export default JarvislyDependentsIndex;
